module.exports = __webpack_public_path__ + "img/settings_other.2432092a.png";